export const filterLabels = {
  intelligenceScopes: 'Inteligências Múltiplas',
  onuGroups: 'Pilares da ONU ',
  onuGoals: 'Agenda 2030',
  twentyfirstCompetences: 'Competências Fundamentais',
  twentyfirstSkills: 'Habilidades do sec. 21',
  oostSubjects: 'Disciplinas Especiais/Contraturno',
  sels: 'Habilidades Socioemocionais'
}



// WEBPACK FOOTER //
// ./src/utils/filterLabels.js